<template>
    <div class="orderInfo">
        <div class="infoItem" style="margin-bottom:1rem">
            <div>Order Status</div>
            <div>{{ getMixinOrderStatus(orderInfo.order_status) }}</div>
        </div>
        <div class="orderList">
            <div class="infoItem">
                <div>Order No.</div>
                <div>{{ orderInfo.order_no }}</div>
            </div>
            <div class="infoItem" v-if="orderInfo.buyer_remark">
                <div>Remark</div>
                <div>{{ orderInfo.buyer_remark }}</div>
            </div>
            <div class="infoItem">
                <div>Payment Method</div>
                <div>{{ orderInfo.pay_type_text || '--'}}</div>
            </div>
            <div class="infoItem">
                <div>Order Time</div>
                <div>{{ formatCreateTime(orderInfo.create_time) }}</div>
            </div>
            <!-- <div class="infoItem">
                <div>Completed Time</div>
                <div>
                    {{ orderInfo.complete_time ? formatTimestamp(orderInfo.complete_time, 'YYYY-MM-DD HH:mm:ss') : '--' }}
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
    import myMixin from '@/utils/myMixin';
    export default {
        name:'OrderInfo',
        mixins:[myMixin],
        props:{
            orderInfo:{
                type:Object,
                default:function(){
                    return {}
                }
            },
            timezone:{
                type:String,
                default:''
            }
        },
        data(){
            return {
            }
        },
        methods:{
            formatCreateTime(timeValue){
                if(!timeValue) return ''
                let date
                if(typeof timeValue === 'string' && timeValue.includes('-')){
                    date = new Date(timeValue.trim().replace(' ', 'T') + 'Z')
                } else {
                    date = new Date(Number(timeValue) * 1000)
                }
                if(isNaN(date.getTime())) return timeValue
                if(this.timezone){
                    try {
                        return new Intl.DateTimeFormat('en-CA', {
                            timeZone: this.timezone,
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                        }).format(date).replace(',', '')
                    } catch(_) {}
                }
                const y = date.getFullYear()
                const m = String(date.getMonth()+1).padStart(2,'0')
                const d = String(date.getDate()).padStart(2,'0')
                const H = String(date.getHours()).padStart(2,'0')
                const i = String(date.getMinutes()).padStart(2,'0')
                return `${y}-${m}-${d} ${H}:${i}`
            }
        }
    }
</script>
<style lang="scss" scoped>
    .orderInfo{
        width: 100%;
        height: auto;
        font-size: .875rem;
        .infoItem{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom:0.5rem;
            &:last-child{
                margin-bottom: 0;
            }
        }
        .orderList{
            width: 100%;
            padding: 1rem;
            box-sizing: border-box;
            background: #EEEEEE;
            border-radius: .5rem;
            font-size: 12px;
            color: #666666;
            line-height: 1.5rem;
        }
    }
</style>
